module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		resourceConnected: false
	},

	methods: {
		dataDealer: function(){
			const storage = this.getStorage()
			this.resourceData = {
				data: {
					attributes: ((storage.session || {}).data || {}).sourceServiceCollectionOptions || {}
				}
			};
		},

		// prevent default submit. save onChange instead.
		submit: function(){},

		/**
		 * this function will be called after the form values has been changed.
		 */
		onChange: function(){
			var profileController;
			var attributes = ((this.model.dirtyFields || {}).data || {}).attributes || {};
			if(Object.keys(attributes).length > 0 && (profileController = getComponent('profileController'))){
				profileController.setServiceCollectionOptions(attributes);
			}
		},
	}
};